"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const index_md_1 = __importDefault(require("./index.md"));
const hljs = __importStar(require("highlight.js"));
const han_css_1 = __importDefault(require("han-css"));
const decrypt_1 = __importDefault(require("../security/decrypt"));
// const PASSWORD_STORAGE_KEY = "password";
function setup() {
    const decryptionForm = document.getElementById("decryption-form");
    const passwordInput = document.getElementById("password");
    const messageParagraph = document.getElementById("message");
    // const savedPassword = localStorage.getItem(PASSWORD_STORAGE_KEY);
    // if (typeof savedPassword === "string") {
    //   if (!reveal(savedPassword)) {
    //     passwordInput.value = "";
    //     messageParagraph.innerText = "保存的密码不正确";
    //   }
    // }
    decryptionForm.addEventListener("submit", (event) => {
        event.preventDefault();
        if (!reveal(passwordInput.value)) {
            passwordInput.value = "";
            messageParagraph.innerText = "密码不正确";
        }
    });
}
exports.default = setup;
function reveal(password) {
    const html = decrypt_1.default(index_md_1.default, password);
    if (html === null) {
        return false;
    }
    else {
        // localStorage.setItem(PASSWORD_STORAGE_KEY, password);
        document.body.innerHTML = html;
        const lastUpdatedTime = document.createElement("div");
        lastUpdatedTime.classList.add("last-update-time");
        lastUpdatedTime.innerText =
            "最后更新日期：" + new Date(LAST_UPDATE_TIMESTAMP).toLocaleString();
        document
            .querySelector("div.title")
            ?.parentElement?.appendChild(lastUpdatedTime);
        hljs.highlightAll();
        han_css_1.default(document.body).render();
        Promise.resolve().then(() => __importStar(require("./components/progress-bar"))).then(({ install }) => install());
        document.querySelectorAll("sup > a").forEach((el, index) => {
            el.innerText = (index + 1).toString();
        });
        return true;
    }
}
